var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "700", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            _vm._l(_vm.periods, function (period, index) {
              return _c(
                "div",
                { key: index, staticClass: "period-item" },
                [
                  _c("div", { staticClass: "period-date-header" }, [
                    _vm._v(
                      "\n          Período: " +
                        _vm._s(_vm.formatPeriodDate(period.startDate)) +
                        " à " +
                        _vm._s(_vm.formatPeriodDate(period.endDate)) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("AppTable", {
                    staticClass: "period-table",
                    attrs: {
                      headers: _vm.getPeriodTableHeaders(),
                      items: [
                        { ...period, _id: period._id || `period-${index}` },
                      ],
                      "hide-title": "",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }